export const LEGAL_FILES = {
  PERSONAL_DATA: 'https://payvalida.com/wp-content/uploads/2022/05/POLITICA_PROTECCION_DE_DATOS.pdf'
};

